import { OnSchedRest }  from "../OnSchedRest";
import { OnSchedUtils } from "../utils";


const CheckErrors = (element, response, reject, resolve) => {
  if (response.error) {
    OnSchedUtils.CheckErrors(element, response)
    .then(reject)
    .catch(reject);
  }
  else resolve(response);
}

export const GetList = (element, searchData) => new Promise((resolve, reject) => {
  const baseUrl = element.onsched.apiBaseUrl + '/' + element.type;
  const url = OnSchedUtils.FormatUrlParams(baseUrl, searchData);
  
  OnSchedRest.Get(url, response => {
    CheckErrors(element, response, reject, resolve);
  })
})
